






























































































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_EMPLOYEE_LIST,
  FETCH_ADDRESS_GROUP,
  FETCH_COUNTRIES_LIST,
  FETCH_SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { ProjectAddressSearchRequestPayload } from '@/types/payload'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import {
  GetCountriesResponse,
  GetSachbearbeiterResponse,
  ProjectAddressSearchResponse
} from '@/types/service-response'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import { AddressCountry } from '@/model/addresses/AddressCountry'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'

interface ComponentData {
  loading: boolean
  landList: AddressCountry[]
  addressGroupList: AddressGroup[]
  sortierung: string
  name: string
  vorname: string
  ort: string
  plz: string
  strasse: string
  region: string
  land: AddressCountry | undefined
  adressgruppe: string
  telefonprivate: string
  telefongeschaftlich: string
  mailprivat: string
  mailgeschaftlich: string
  maxRecords: number
  addressList: SearchAddress[],
  sachbearbeiterList: SearchAddressEmployee[]
  timerId: any
  focusedRowKey: number
  focusedRowKey2: number
}

export default Vue.extend({
  name: 'CreateProjectAddressSearch',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      loading: false,
      landList: [],
      addressGroupList: [],
      sortierung: '',
      name: '',
      vorname: '',
      ort: '',
      plz: '',
      strasse: '',
      region: '',
      land: undefined,
      adressgruppe: '',
      telefonprivate: '',
      telefongeschaftlich: '',
      mailprivat: '',
      mailgeschaftlich: '',
      maxRecords: 500,
      addressList: [],
      sachbearbeiterList: [],
      timerId: undefined,
      focusedRowKey: -1,
      focusedRowKey2: -1
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    rowDblClick(event: any): void {
      clearTimeout(this.timerId)
      this.$emit('selectedAddress', event.data)
    },

    rowEmployeeDblClick (event: any): void {
      this.$emit('selectedAddressEmployee', event.data)
    },

    onSearchButtonClick (): void {
      this.searchAddress()
    },

    async fetchAddressEmployee(addressId: number): Promise<void> {
      try {
        const response: GetSachbearbeiterResponse = await this.$store.dispatch(FETCH_ADDRESS_EMPLOYEE_LIST, addressId)
        if(!response.IsError && response.Data) {
         this.sachbearbeiterList = SearchAddressEmployee.createFromResponse(response.Data)
        }
      } catch {
      }
    },

    async searchAddress (): Promise<void> {
      const payload: ProjectAddressSearchRequestPayload = {
        Sortierung: this.sortierung,
        Adressgruppe: this.adressgruppe ? this.adressgruppe : '',
        Name: this.name,
        Region: this.region,
        Vorname: this.vorname,
        Land: this.land ? this.land.name : '',
        Ort: this.ort,
        Telefonprivate: this.telefonprivate,
        Telefongeschaftlich: this.telefongeschaftlich,
        AdressZusatzfelderSearchItems: [],
        PLZ: this.plz,
        Mailprivat: this.mailprivat,
        Strasse: this.strasse,
        Mailgeschaftlich: this.mailgeschaftlich,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId,
        MaxRecords: this.maxRecords,
        Aktiv: true,
        Passiv: false,
        Alle: false
      }

      try {
        this.loading = true
        const response: ProjectAddressSearchResponse = await this.$store.dispatch(FETCH_SEARCH_ADDRESS_LIST, payload)
        if(!response.IsError) {
          this.addressList = SearchAddress.createFromResponse(response.Results)
          if(this.addressList.length > 0) {
            //@ts-ignore
            this.$refs.dataGrid1.instance.option("focusedRowIndex", -1);
            //@ts-ignore
            this.$refs.dataGrid2.instance.option("focusedRowIndex", -1);
            this.focusedRowKey = 0
                this.focusedRowKey2 = 0
            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid1.instance.focus()
              this.focusedRowKey = this.addressList[0].id
            }, 100)
          }
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    onFocusedRowChanged (e: any): void {
      this.focusedRowKey = e.component.option('focusedRowKey')
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.fetchAddressEmployee(this.focusedRowKey)
      }, 320)
    },

    onKeyDown1 (e: any): void {
      if(e.event.key === "Enter") {
        const foundAddress: SearchAddress | undefined = this.addressList.find((item: SearchAddress) => item.id === this.focusedRowKey)
        if(foundAddress) {
          this.$emit('selectedAddress', foundAddress)
        }
      } else if(e.event.key === "Tab") {
        if(this.sachbearbeiterList.length > 0) {
          setTimeout(() => {
            //@ts-ignore
            this.$refs.dataGrid2.instance.focus()
            this.focusedRowKey2 = this.sachbearbeiterList[0].sachbearbeiterID
          }, 100)
        }
      }
    },

    onFocusedRowChanged2 (e: any): void {
      this.focusedRowKey2 = e.component.option('focusedRowKey')
    },

    onKeyDown2 (e: any): void {
      if(e.event.key === "Enter") {
        const foundAddressEmployee: SearchAddressEmployee | undefined = this.sachbearbeiterList.find((item: SearchAddressEmployee) => item.sachbearbeiterID === this.focusedRowKey2)
        if(foundAddressEmployee) {
          this.$emit('selectedAddressEmployee', foundAddressEmployee)
        }
      }
    },

    onFocusedCellChanging (e: any) {
      e.isHighlighted = false
    },
  },

  async mounted (): Promise<void> {
    setTimeout(() => {
      const filterField: any = this.$refs['filterField']
      if (filterField) {
        filterField.focus()
      }
    })
    const response: GetCountriesResponse = await this.$store.dispatch(FETCH_COUNTRIES_LIST)
    this.landList = !response.IsError ? AddressCountry.createFromResponse(response.Countries) : []
    this.addressGroupList = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
  }
})
